import { SORT_FIELD } from "@/constants";

import type { Asset } from "../types";

function sortByCreatedAt(a: Asset, b: Asset, sortOrientation: string) {
  if (sortOrientation === "ASC") {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  } else {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  }
}

function sortByName(a: Asset, b: Asset, sortOrientation: string) {
  if (sortOrientation === "ASC") {
    return a.name.localeCompare(b.name);
  } else {
    return b.name.localeCompare(a.name);
  }
}

/**
 * Sorts assets.
 */
export function sortAssets(assets: Asset[], sortField: string, sortOrientation: string) {
  return [...assets].sort((a, b) => {
    switch (sortField) {
      case SORT_FIELD.MEDIA_ITEM_CREATED_AT:
        return sortByCreatedAt(a, b, sortOrientation);
      case SORT_FIELD.MEDIA_ITEM_NAME:
        return sortByName(a, b, sortOrientation);
      case SORT_FIELD.MEDIA_ITEM_TYPE:
        return sortOrientation === "ASC"
          ? a.contentType?.name.localeCompare(b.contentType?.name)
          : b.contentType?.name.localeCompare(a.contentType?.name);
      case SORT_FIELD.MEDIA_ITEM_CREATED_BY:
        return sortOrientation === "ASC"
          ? a.createdBy?.name?.localeCompare(b.createdBy?.name)
          : b.createdBy?.name?.localeCompare(a.createdBy?.name);
      case SORT_FIELD.MEDIA_ITEM_SIZE:
        return sortOrientation === "ASC" ? a.fileSize - b.fileSize : b.fileSize - a.fileSize;
      default:
        return 0;
    }
  });
}
